export default [
	{
		id: 1,
		title: '文旅大数据',
		path: '/tourismData',
		name: 'TourismData',
		component: () => import('../views/content/tourismData/index.vue')
	},
	{
		id: 2,
		title: '综合服务',
		path: '/integratedServices',
		name: 'IntegratedServices',
		component: () => import('../views/content/integratedServices/index.vue')
	},
	{
		id: 3,
		title: '文旅营销',
		path: '/tourismMarketing',
		name: 'TourismMarketing',
		component: () => import('../views/content/tourismMarketing/index.vue')
	},
	{
		id: 4,
		title: '综合管理',
		path: '/integratedManagement',
		name: 'IntegratedManagement',
		component: () => import('../views/content/integratedManagement/index.vue')
	},
	{
		id: 5,
		title: '视频监控',
		path: '/videoSurveillance',
		name: 'VideoSurveillance',
		component: () => import('../views/content/videoSurveillance/index.vue')
	},
	{
		id: 6,
		title: '游客中心',
		path: '/touristCenter',
		name: 'TouristCenter',
		component: () => import('../views/content/touristCenter/index.vue')
	},
	{
		id: 7,
		title: '应急指挥',
		path: '/emergencyManagement',
		name: 'EmergencyManagement',
		component: () => import('../views/content/emergencyManagement/index.vue')
	},
	{
		id: 8,
		title: '指挥中心',
		path: '/commandCentre',
		name: 'CommandCentre',
		component: () => import('../views/content/commandCentre/index.vue')
	},
]